import createStore from '@korijn/vue-store';

//Store values (state), readonly
const initialState = {
    side: {},//clientside or serverside
    allValues: {},//All original values
    sortedValues: {},//Values sorted/paged
    currentTableId: {},//Unique table id
    currentCol: {},//Column
    currentDir: {},//Direction
    pageSize: {},//Rows per page
    currentPage: {},//Page number
    currentSearch: {},//Table search term
    currentFilters: {},//Table filters (only server side atm)
};

//Store mutations, only way to change state values
const mutations = {
    changeSide(state, { id, side }) {
        state.side[id] = side;
    },
    changeAllValues(state, { id, values }) {
        state.allValues[id] = values;
        mutations.sortValues(state, {id: id});
    },
    changeSortedValues(state, { id, values }) {
        state.sortedValues[id] = values;
    },
    changeTableId(state, { id }) {
        state.currentTableId = id;
    },
    changeCol(state, {id, column}) {
        state.currentCol[id] = column;
    },
    changeDir(state, {id, dir}) {
        state.currentDir[id] = dir;
    },
    sortValues(state, {id}) {

        if (state.side[id] === 'client' && state.currentCol[id] !== null)
        {
            const column = state.currentCol[id].split('.')//for relational columns

            state.sortedValues[id] = state.allValues[id].sort((a,b) => {
                let modifier = 1;

                if (column.length > 1)
                {
                    column.forEach(function(columnPart) {
                        a = (a !== null) ? a[columnPart] : null;
                        b = (b !== null) ? b[columnPart] : null;
                    });
                } else
                {
                    a = a[state.currentCol[id]];
                    b = b[state.currentCol[id]];
                }

                if(state.currentDir[id] === 'desc')
                    modifier = -1;

                if (typeof a !== 'undefined' && typeof b !== 'undefined')
                {
                    if (a === null || a === '')
                    {
                        return 1 * modifier;
                    }
                    else if (b === null || b === '')
                    {
                        return -1 * modifier;
                    }
                    else if (!isNaN(a) && !isNaN(b))
                    {
                        if (a < b)
                        {
                            return -1 * modifier;
                        }
                        else if (a > b)
                        {
                            return 1 * modifier;
                        }
                    }
                    else if (a.toString().toLowerCase() < b.toString().toLowerCase())
                    {
                        return -1 * modifier;
                    }
                    else if (a.toString().toLowerCase() > b.toString().toLowerCase())
                    {
                        return 1 * modifier;
                    }
                }

                return 0;
            }).filter((row, index) => {
                //for paging
                let start = (state.currentPage[id] - 1) * state.pageSize[id];
                let end = state.currentPage[id] * state.pageSize[id];

                if (index >= start && index < end) {
                    return true;
                } else {
                    return false;
                }
            });
        }
        else
        {
            if (state.allValues[id].data)
            {
                state.sortedValues[id] = state.allValues[id].data;
            }
            else
            {
                state.sortedValues[id] = state.allValues[id];
            }
        }
    },
    changePageSize(state, { id, pageSize }) {
        state.pageSize[id] = pageSize;
    },
    changeCurrentPage(state, { id, currentPage }) {
        state.currentPage[id] = currentPage;
    },
    changeCurrentSearch(state, {id, search}) {
        state.currentSearch[id] = search;
    },
    changeCurrentFilters(state, {id, filters}) {
        state.currentFilters[id] = filters;
    },
}

const store = createStore(initialState, mutations);

export default {
    ...store,
};
